export default "__VITE_ASSET__Bh1Kv9ZJ__"